import React from "react";

export default function EditDeleteButtons({
  onClickDestructiveButton,
  destructiveButtonText,
  onClickActionButton,
  actionButtonText,
}) {
  return (
    <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2">
      <div
        onClick={onClickDestructiveButton}
        className={
          "w-full font-medium text-danger bg-danger-subtle hover:bg-red-100 dark:hover:bg-red-900/40 rounded-full text-sm text-center cursor-pointer py-1 px-3 transition-all focus:outline-hidden"
        }
      >
        {destructiveButtonText}
      </div>
      <div
        onClick={onClickActionButton}
        className={
          "w-full font-medium text-white bg-brand hover:bg-indigo-600 rounded-full text-sm text-center cursor-pointer py-1 px-3 transition-all focus:outline-hidden"
        }
        data-testid={`action-button-${actionButtonText}`}
      >
        {actionButtonText}
      </div>
    </div>
  );
}
